//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { hCaptchaMixin, hCaptchaUtils } from '~/mixins/captcha'
import contactMentorsForm from '~/mixins/contactMentorsForm.js'
import { privacyLinkId } from '~/utils/gcmsIds'
import getLink from '~/gql/getLink'

export default {
  mixins: [contactMentorsForm, hCaptchaMixin],
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
    answers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      link: null,
      formData: {
        firstname: null,
        lastname: null,
        email: null,
        phone: null,
        postcode: null,
        country: null,
        clinic: null,
        privacy: false,
        newsletter: false,
      },
      invalidFields: {
        firstname: false,
        lastname: false,
        email: false,
        privacy: false,
        newsletter: false,
      },
    }
  },

  async fetch() {
    const { link } = await this.$graphcms.request(getLink, {
      id: privacyLinkId,
      lang: [this.$i18n.locale, this.$i18n.defaultLocale],
    })
    this.link = link ?? null
  },

  computed: {
    privacyHint() {
      if (!this.link) return null
      const privacyLink = `<a href="${this.link.url}" title="${this.link.title}" target="_blank">${this.link.title}</a>`
      const translation = this.$translation('form.privacyHint', { privacyLink })
      return translation
    },
    captchaLanguage() {
      const locale = this.$i18n.locale
      if (locale.includes('_')) {
        return locale.split('_')[0]
      }
      return locale
    },
  },
  methods: {
    formattedAnswer(index = 0) {
      return this.answers.length > 0 ? this.answers[3][index] : ''
    },

    onCaptchaVerify(token) {
      hCaptchaUtils.handleVerify(this, token)
      // Also emit to parent
      this.$emit('input', { captchaToken: token, captchaValid: true })
    },

    onCaptchaError(error) {
      hCaptchaUtils.handleError(this, error)
      this.$emit('input', { captchaToken: null, captchaValid: false })
    },

    onCaptchaExpired() {
      hCaptchaUtils.handleExpire(this)
      this.$emit('input', { captchaToken: null, captchaValid: false })
    },
  },
}
